import CryptoJS from "crypto-js";

const HASHKEY = import.meta.env.VITE_HASHKEY;

export const prpHttpAPI = async (data, path, localtoken = null, method = "GET", currentPage = null) => {

  try {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append('x-page-location', currentPage)
    console.log('location----------', currentPage);
    if (localtoken) {
      myHeaders.append("Authorization", `Bearer ${localtoken}`)
    }
    let url = `${import.meta.env.VITE_URL}${path}`;
    let requestOptions = {
      method: method,
      headers: myHeaders,
      redirect: "follow",
    };

    if (method === "POST" || method === "PUT") {
      // Encrypt the data only for POST/PUT requests
      const ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        HASHKEY
      ).toString();

      requestOptions.body = JSON.stringify({ data: ciphertext });
    } else if (method === "GET" && data) {
      // Convert data object to query parameters for GET request
      const queryParams = new URLSearchParams(data).toString();
      url += `?${queryParams}`;
    }

    const response = await fetch(url, requestOptions);
    // console.log(response.status)
    const result = await response.json();
    result.status = response.status

    // Invalid/expired token -> clear session and go to login
    if (localtoken && result?.success === false && /token|signature/i.test(result.msg || "")) {
      localStorage.clear();
      window.location.href = `${window.location.origin}/login`;
      return;
    }

    return result;
  } catch (error) {
    console.error("There is some error:", error.message);
  }
};